<template>
  <div id="Page-Template">
    <section id="key-vision" class="bg-secondary-dark" v-lazy:background-image="pageBanner" v-if="$route.name !== 'Redeem'">
      <div
        :class="{'container': screenWidth>=768}"
        class="h-100 d-flex align-items-center justify-content-start"
      >
        <div
          class="title d-flex d-md-block"
          style="display:none!important"
          v-lazy:background-image="'/img/section-title.png'"
          data-aos="zoom-in-up"
          data-aos-easing="ease-out-back"
          data-aos-delay="50"
          data-aos-duration="700"
        >
          <h1>{{pageTitle}}</h1>
        </div>
      </div>
    </section>
    <section>
      <div class="container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb d-flex align-items-center justify-content-start bg-white mt-10">
            <li class="breadcrumb-item">
              <router-link to="/">首頁</router-link>
            </li>
            <li class="breadcrumb-item" :class="{'d-none':parentPage===''}">
              <router-link :to="{name:parentPage[1]}">{{parentPage[0]}}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{pageTitle}}</li>
          </ol>
        </nav>
        <router-view
          @sendTitle="sendTitle"
          data-aos-easing="ease-out-back"
          data-aos="fade-up"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-anchor-placement="top-bottom"
        />
      </div>
    </section>
  </div>
</template>
<script>
/* eslint-disable global-require */
import { mapGetters } from 'vuex';

export default {
  name: 'Page-Template',
  data() {
    return {
      title: '',
    };
  },
  components: {},
  methods: {
    sendTitle(title) {
      this.title = title;
    },
  },
  computed: {
    ...mapGetters(['screenWidth']),
    pageTitle() {
      if (this.title === '') {
        switch (this.$route.name) {
          case 'News':
            return '最新消息';
          case 'Special-Offer':
            return '會員專屬優惠';
          case 'Terms':
            return '使用者條款';
          case 'Privacy':
            return '隱私權條例';
          case 'QA':
            return '常見問題';
          case 'Service':
            return 'HS超集點';
          case 'Partners':
            return '合作商家';
          case 'Redeem':
            return 'HS超集點兌換活動';
          case 'Upgrade':
            return ' 年度累積消費達標';
          default:
            return 'HS超集點';
        }
      } else {
        return this.title;
      }
    },
    pageBanner() {
      return require('@/assets/image/banner-7.jpg');
      /*
      switch (this.$route.name) {
        case 'News':
          return require('@/assets/image/banner-6.jpg');
        case 'Special-Offer':
          return require('@/assets/image/banner-3.jpg');
        case 'Coupon':
          return require('@/assets/image/banner-3.jpg');
        case 'Service':
          return require('@/assets/image/banner-5.jpg');
        case 'Redeem':
          return require('@/assets/image/banner-7.jpg');
        case 'Terms':
          return require('@/assets/image/banner-4.jpg');
        case 'Privacy':
          return require('@/assets/image/banner-4.jpg');
        case 'QA':
          return require('@/assets/image/banner-4.jpg');
        default:
          return require('@/assets/image/banner-7.jpg');
      }
      */
    },
    parentPage() {
      if (this.title !== '') {
        switch (this.$route.name) {
          case 'Coupon':
            return ['會員專屬優惠', 'Special-Offer'];
          default:
            return ['齊來卡', 'home'];
        }
      } else {
        return '';
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 500);
    });
  },
  watch: {
    $route() {
      this.title = '';
    },
  },
};
</script>
<style lang="scss" scoped>
#Page-Template {
  #key-vision {
    position: relative;
    width: 100%;
    height: 400px;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    z-index: 0;
    @media (min-width: 576px) {
      height: 450px;
    }
   /* &::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.4);
    } */
    .title {
      position: relative;
      z-index: 10;
      width: 600px;
      max-width: 100vw;
      height: 300px;
      max-height: calc(100vw * 0.454);
      background-size: contain;
      background-repeat: no-repeat;
      margin: 0 auto;
      align-self: flex-start;
      @media (min-width: 576px) {
        max-height: auto;
      }
      @media (min-width: 768px) {
        align-self: center;
        margin: 0;
      }
      h1 {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        font-size: 22px;
        @media (min-width: 576px) {
          font-size: 30px;
          bottom: 30px;
        }
      }
    }
  }
  nav > .breadcrumb {
    border-bottom: 1px solid #979797;
    border-radius: 0;
    li {
      padding-right: 20px;
      margin: 10px 0;
      font-size: $font-size-sm;
      line-height: $font-size-sm;
      &:not(:first-of-type) {
        padding: 0 20px;
        border-left: 1px solid #000;
        &::before {
          content: '';
          padding: 0;
        }
      }
      &.active {
        color: $primary-light;
      }
      a:hover {
        color: $sub-primary-strong;
      }
    }
  }
}
</style>
